<template>
  <div class="add-to-basket">
    <div class="d-flex justify-content-end flex-column flex-lg-row">
      <div
        class="d-flex justify-content-center quantity mr-lg-2 mb-4 mb-lg-0"
        :disabled="loading"
      >
        <button @click="quantity > 1 && quantity--" class="btn left px-3">
          <i class="far fa-minus"></i>
        </button>
        <input
          v-model="quantity"
          type="number"
          class="form-control px-1 text-center"
        />
        <button @click="quantity < max && quantity++" class="btn right px-3">
          <i class="far fa-plus"></i>
        </button>
      </div>

      <button
        @click="addToBasket()"
        type="button"
        class="btn btn-primary flex-shrink-1"
      >
        Add To Basket
      </button>
    </div>
    <div class="row" v-if="stockWarningMessage && basketProductId">
      <div class="col mt-2">
        <p :class="'stock-warning ' + stockWarningMessage.colour.toLowerCase()">
          {{ stockWarningMessage.name }}
        </p>
      </div>
    </div>

    <div
      v-if="loading"
      class="d-flex align-items-center justify-content-center"
    >
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div v-if="success" class="alert alert-success mt-4 mb-0">
      <span v-if="name"
        ><strong>{{ quantity }}</strong> x <strong>{{ name }}</strong> has been
        added to your basket.</span
      >
      <span v-else>The product has been added to your basket.</span>
    </div>

    <div
      v-for="message in messages"
      class="mt-4 alert mb-0"
      :class="'alert-' + message.type"
      v-if="typeof message.global === 'undefined'"
    >
      {{ message.content }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      success: false,
      messages: [],
      stockWarningMessage: null,
    };
  },

  props: {
    productId: {
      type: Number,
    },
    schoolId: {
      type: Number,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    addonText: {
      type: String,
      default: null,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    name: {
      type: String,
    },
  },

  watch: {
    quantity: function (newQuantity, oldQuantity) {
      // validate quantity
      this.quantity = isNaN(this.quantity) ? 1 : this.quantity;
      this.quantity = this.quantity > this.max ? this.max : this.quantity;
      this.quantity = this.quantity < 1 ? 1 : this.quantity;
    },
  },

  mounted() {
    //
  },

  methods: {
    addToBasket() {
      this.loading = true;

      axios
        .post("/api/v1/basket/add", {
          school_id: this.schoolId,
          items: [
            {
              product_id: this.productId,
              quantity: this.quantity,
              addon_item_comment: this.addonText,
            },
          ],
        })
        .then((res) => {
          if (res.data && res.data.messages) {
            this.messages = res.data.messages;
          }

          if (res.data && res.data.success) {
            this.success = true;
            this.$root.basket = res.data.basket;
            this.$root.showMiniBasket = true;
          } else {
            this.success = false;
          }
        })
        .catch((err) => {
          this.messages = [];
          for (const msg in err.response.data.errors) {
            this.messages.push({
              type: "danger",
              content: err.response.data.errors[msg][0],
            });
          }
          this.success = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
